import api from './api';

export interface Tag {
  id: number;
  name: string;
  color: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface TagSearchResponse {
  success: boolean;
  data: Tag[];
}

export interface AttachTagsRequest {
  tag_names: string[];
}

export interface AttachTagsResponse {
  success: boolean;
  data: Tag[];
}

class TagService {
  // 搜索标签（自动建议）
  async searchTags(query: string): Promise<TagSearchResponse> {
    const response = await api.get('/tags/search', {
      params: { query }
    });
    return response.data;
  }

  // 为商标添加标签
  async attachTagsToTrademark(trademarkId: number, tagNames: string[]): Promise<AttachTagsResponse> {
    const response = await api.post(`/trademarks/${trademarkId}/tags`, {
      tag_names: tagNames
    });
    return response.data;
  }

  // 获取商标的标签
  async getTrademarkTags(trademarkId: number): Promise<TagSearchResponse> {
    const response = await api.get(`/trademarks/${trademarkId}/tags`);
    return response.data;
  }

  // 创建新标签
  async createTag(name: string, color?: string, description?: string): Promise<{ success: boolean; data: Tag }> {
    const response = await api.post('/tags', {
      name,
      color: color || '#1890ff',
      description
    });
    return response.data;
  }
}

export default new TagService();